<template>
  <div class="mt-4 ms-8">
    <div class="text-h6 font-weight-bold" style="color: #424242;">
      Billing Policy
    </div>
    <p style="color: #808080;font-weight: bold;">No term or commitment. Cancel anytime. When you add or a delete a user you will be charged $40/day or $1000/month, whichever is less. At the beginning of the month you will be charged the monthly account fee of $1500 plus the monthly per additional user fee of $1000. Your agreed upon discount will be subtracted from
    the invoice total. Charges are pro-rated and you will receive a refund when an overpayment occurs due to deleting additional users or cancellation. Refunds are issued on the 1st day
    of the month following any user deletions or account cancellations. Telecomm (phone usage) is charged at 12.5 cents per minute, slightly above our cost. Telecomm charges
    will be billed the following month. So in March, for example, you would be charged $1500 at the beginning of the month plus the telecomm fee for February minus your agreed
    upon discount.</p>
  </div>
  
  <div class="radio-group mt-4 ms-8" style="margin-bottom: -26px;">
    <div class="text-h6 font-weight-bold" style="color: #424242;margin-bottom: -14px;">
      For our monthly billing
    </div>
    <v-radio-group v-model="selectedPaymentType" class="mt-4" @change="handlePaymentTypeChange">
      <v-radio
        v-for="(label, type) in paymentType"
        :key="type"
        :value="type"
      >
        <template v-slot:label>
          <span style="font-size: 17px; font-weight: bold; color: #424242;">
            {{ label }}
          </span>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
  <div id="discount" v-if="getSelectedCompany?.billing?.discount" class="mt-3 ms-8" style="margin-bottom: 30px; display:block;">
    <div class="text-h6 font-weight-bold" style="color: #424242;margin-top: 0px">
      Discount to be subtracted from invoice total
    </div>
    <p class="ms-3" style="color: #808080;font-weight:bold;margin-top: 6px;">{{ getSelectedCompany?.billing?.discount }}</p>
  </div>
</template>

<script>
import { ref } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';

export default {
  name: 'CustomerAgreementOrderForm',
  
  computed: {
    ...mapGetters(['getSelectedCompany'])
  },

  setup() {
    const selectedPaymentType = ref(null);
    
    const paymentType = {
      INVOICE: 'we  prefer to be invoiced monthly',
      AUTOPAY: 'we prefer autopay'
    };

    return {
      selectedPaymentType,
      paymentType
    };
  },

  methods: {
    ...mapActions(['setSelectedCompany']),

    async initializeBilling() {
      if (!this.getSelectedCompany?.billing) {
        try {
          const response = await axios.put(
            `/portaldb/db/updateCompanyProperties/${this.getSelectedCompany.companyNumber}`,
            {
              billing: {
                paymentType: 'INVOICE',
                discount: ''
              }
            }
          );
          
          if (response.data.success) {
            const updatedCompany = {
              ...this.getSelectedCompany,
              billing: {
                paymentType: 'INVOICE',
                discount: ''
              }
            };
            this.setSelectedCompany(updatedCompany);
          }
        } catch (error) {
          console.error('Error initializing billing:', error);
        }
      }
      this.selectedPaymentType = this.getSelectedCompany?.billing?.paymentType || 'INVOICE';
    },

    async handlePaymentTypeChange(newValue) {
      const paymentType = newValue?.target?.value || newValue;
      try {
        const response = await axios.put(
          `/portaldb/db/updateCompanyProperties/${this.getSelectedCompany.companyNumber}`,
          {
            billing: {
              paymentType,
              discount: this.getSelectedCompany?.billing?.discount || ''
            }
          }
        );
        
        if (response.data.success) {
          const updatedCompany = {
            ...this.getSelectedCompany,
            billing: {
              paymentType,
              discount: this.getSelectedCompany?.billing?.discount || ''
            }
          };
          this.setSelectedCompany(updatedCompany);
        }
      } catch (error) {
        console.error('Error updating payment type:', error);
      }
    }

  },

  mounted() {
    this.initializeBilling();
  }

};
</script>

<style scoped>
.radio-group {
  margin-bottom: 24px;
}
</style>
